export default __webpack_public_path__ + "static/truemed-step-1-b1cd2aa4d7ba87194e03164046cc4404.png";